import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AbpHttpInterceptor } from "abp-ng2-module";

import * as ApiServiceProxies from "./service-proxies";

@NgModule({
  providers: [
    ApiServiceProxies.PricingServiceProxy,
    // ApiServiceProxies.ReservationServiceProxy,
    ApiServiceProxies.ReservationAppServiceV2ServiceProxy,
    ApiServiceProxies.QRCodeServiceProxy,
    ApiServiceProxies.SlotServiceProxy,
    ApiServiceProxies.LocationManagementServiceProxy,
    ApiServiceProxies.LookupServiceProxy,
    ApiServiceProxies.RoleServiceProxy,
    ApiServiceProxies.SessionServiceProxy,
    ApiServiceProxies.TenantServiceProxy,
    ApiServiceProxies.UserServiceProxy,
    ApiServiceProxies.TokenAuthServiceProxy,
    ApiServiceProxies.AccountServiceProxy,
    ApiServiceProxies.ConfigurationServiceProxy,
    ApiServiceProxies.AuditLogServiceProxy,
    ApiServiceProxies.StaffAccountServiceProxy,
    ApiServiceProxies.ViolationTypeServiceProxy,
    ApiServiceProxies.ViolationServiceProxy,
    ApiServiceProxies.ViolationAdminServiceProxy,
    ApiServiceProxies.FinancialServiceProxy,
    ApiServiceProxies.StaffAccountShiftServiceProxy,
    ApiServiceProxies.ManualIncomeServiceProxy,
    ApiServiceProxies.SubscriptionVehicleServiceProxy,
    ApiServiceProxies.SubscriptionVehicleQRCodeServiceProxy,
    ApiServiceProxies.CustomerQRCodeServiceProxy,
    ApiServiceProxies.StaffGroupServiceProxy,
    ApiServiceProxies.SubscriptionCompanyServiceProxy,
    ApiServiceProxies.SubscriptionServiceProxy,
    ApiServiceProxies.StaffGroupShiftServiceProxy,
    ApiServiceProxies.SubscriptionPackageServiceProxy,
    ApiServiceProxies.SubscriptionTimeZoneServiceProxy,
    ApiServiceProxies.InOutReservationPricingServiceProxy,
    ApiServiceProxies.InOutReservationServiceProxy,
    ApiServiceProxies.LostInOutReservationTicketServiceProxy,
    ApiServiceProxies.FinancialServiceProxy,
    ApiServiceProxies.MetricAdminServiceProxy,
    ApiServiceProxies.OperationNoteServiceProxy,
    ApiServiceProxies.TransactionServiceProxy,
    ApiServiceProxies.ZatcaDeviceServiceProxy,
    ApiServiceProxies.ParkingInvoicesServiceProxy,
    ApiServiceProxies.IntegrationIntegrityLogsServiceProxy,
    ApiServiceProxies.ZatcaIntegrityLogsServiceProxy,
    ApiServiceProxies.CancellationRequestServiceProxy,
    ApiServiceProxies.CustomerServiceProxy,
    ApiServiceProxies.VehicleServiceProxy,
    ApiServiceProxies.StatisticsServiceProxy,
    ApiServiceProxies.VehicleListingServiceProxy,
    ApiServiceProxies.GetUserExportRequestsServiceProxy,
    ApiServiceProxies.FailureLogsServiceProxy,
    { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
  ],
})
export class ServiceProxyModule { }
